import { TypewriterText } from './../TypewriterText'


// Contenido de las páginas de "Atención" (Instructor y Líder): título y subtítulo, código QR, frases
// con efecto de máquina de escribir, medios de contacto y horario de atención. Los estilos son los de
// Instructor__Support__* (ver _support.sass).

// Datos de contacto (los mismos de la página Contacto).
const CONTACT = {
    phoneText: '(+52 1 444) 707 7110',
    phoneLink: 'tel:+524447077110',
    emailText: 'ux@ztudia.com',
    emailLink: 'mailto:ux@ztudia.com',
    whatsappText: '(+52 1 444) 707 7110',
    whatsappLink: 'https://wa.me/524447077110'
}

// Frases que se escriben con efecto de máquina de escribir, una tras otra.
const TYPEWRITER_PHRASES = [
    '¿Quieres saber si el centro de cómputo está listo para las evaluaciones?',
    '¿Tienes dudas con respecto al funcionamiento de Ztudia?',
    '¿Tienes dudas en algún tema del curso?',
    '¿Quieres conocer más certificaciones del catálogo Ztudia?',
    '¿Requieres atención en un horario diferente?'
]

/**
 * @param {string} title - Título de la página, por ejemplo "Atención al Instructor".
 */
const SupportContent = ({ title }) => (
    <section className='container Instructor__Support'>
        <p className='Instructor__Title Instructor__Title--Center Instructor__SpaceUp'>{title}</p>
        <p className='Instructor__Support__Subtitle'>Nuestro equipo de expertos está listo para atenderte con gusto</p>

        <img src='/img/support/qr-atencion-instructor.png' alt={`Código QR de ${title}`} className='Instructor__Support__Qr' />

        <TypewriterText phrases={TYPEWRITER_PHRASES} extraClassName='Instructor__Support__Typewriter' />

        <div className='Instructor__Support__Contact'>
            <div className='Instructor__Support__Contact__Buttons'>
                <a href={CONTACT.phoneLink} className='Instructor__Support__Contact__Button Instructor__Support__Contact__Button--Blue'>
                    <i className='bi bi-telephone'></i> {CONTACT.phoneText}
                </a>
                <a href={CONTACT.emailLink} className='Instructor__Support__Contact__Button Instructor__Support__Contact__Button--Purple'>
                    <i className='bi bi-envelope'></i> {CONTACT.emailText}
                </a>
                <a href={CONTACT.whatsappLink} target='_blank' rel='noopener noreferrer' className='Instructor__Support__Contact__Button Instructor__Support__Contact__Button--Orange'>
                    <i className='bi bi-whatsapp'></i> {CONTACT.whatsappText}
                </a>
            </div>

            <div className='Instructor__Support__Contact__Schedule'>
                <p className='Instructor__Support__Contact__Schedule__Text'>Horario de atención</p>
                <p className='Instructor__Support__Contact__Schedule__Text'>Lunes a Viernes de 08:00 a 17:30 hrs.</p>
                <p className='Instructor__Support__Contact__Schedule__Text'>Sábados de 08:00 a 14:00 hrs. (Hora de CDMX)</p>
            </div>
        </div>
    </section>
)

export { SupportContent }
